import {Component, EventEmitter, Input, OnInit, Output, SimpleChange} from '@angular/core';
import {CompareValueService} from '../../shared/compare-value.service';

import {CourseService} from '../../shared/course.service';
import {Course, CourseList} from '../../shared/interface/course.interface';

@Component({
    selector: 'app-course-course-list',
    templateUrl: './course-list.component.html',
    styleUrls: ['./course-list.component.scss']
})
export class CourseListComponent implements OnInit {
    @Input() termCode: string;
    @Input() section: string;

    @Input() netId: string;
    @Output() hasDataLoaded: EventEmitter<boolean> = new EventEmitter<boolean>();

    courseList: Array<Course>;
    displayCourseList: Array<Course> = [];
    isDataLoaded: boolean = false;
    getCourseCallStarted: boolean = false;

    constructor(private courseService: CourseService, private compareValueService: CompareValueService) {
    }

    ngOnInit(): void {
        // initialize term listing that is available.
    }

    getCourseList(termCode: string, netId: string, section: string, applySectionFilter: boolean = true) {
        // set service
        const applySection = applySectionFilter ? section : null;

        if (this.getCourseCallStarted === false) {
            this.hasDataLoaded.emit(this.isDataLoaded);
            this.getCourseCallStarted = true;
            this.courseService.get(termCode, netId, applySection).subscribe((response: CourseList) => {
                this.displayCourseList = [];
                this.isDataLoaded = true;
                this.hasDataLoaded.emit(this.isDataLoaded);
                if (response.list.length > 0) {
                    this.courseList = response.list?.filter(function (c: Course) {
                        return c.enrollment > 0
                    });

                    for (let i = 0; i < this.courseList.length; i++) {
                        if (this.courseList[i].enrollment > 0) {
                            this.displayCourseList.push(this.courseList[i]);
                        }
                    }
                    this.updateDisplayCourseList(section);
                }
                this.getCourseCallStarted = false;
            });
        }
    }

    sortCourseList() {
        const compareValueService = this.compareValueService;

        if (this.displayCourseList?.length > 0) {
            this.displayCourseList = this.displayCourseList.sort(function (a: Course, b: Course) {
                const aCourse = a.displayCourseString.toUpperCase();
                const bCourse = b.displayCourseString.toUpperCase();
                return compareValueService.sortValue(aCourse, bCourse);
            });
        }

    }

    updateDisplayCourseList(sectionFilter: string) {
        const canBeGraded: boolean = sectionFilter == 'gradable';
        this.displayCourseList = [];

        if (sectionFilter) {
            this.displayCourseList = this.courseList?.filter(function (c: Course) {
                return c.canCourseBeGraded == canBeGraded;
            });
        } else {
            this.displayCourseList = this.courseList;
        }
        if (!this.displayCourseList) {
            this.displayCourseList = [];
        }
        this.sortCourseList();
        this.isDataLoaded = true;
        this.hasDataLoaded.emit(this.isDataLoaded);
    }

    ngOnChanges(changes: SimpleChange): void {
        // clear up display course list
        this.displayCourseList = [];
        this.isDataLoaded = false;
        const sectionFilter = changes['section']?.currentValue ? changes['section'].currentValue : this.section;

        console.log(changes);
        console.log(this.section);

        if (changes['termCode']) {
            this.getCourseList(this.termCode, this.netId, this.section, false);
        } else {
            if (changes['section'] && !changes['termCode']) {
                this.updateDisplayCourseList(sectionFilter);
            }
        }

    }

    setCurrentCourse(course: Course) {
        this.courseService.setCurrentCourse(course);
    }
}
